import { createAsyncAction } from 'typesafe-actions';

import type {
  DemandApi,
  SecondLookOfferConfiguration,
  SecondLookOfferConfigurationCreateData,
} from '@evenfinancial/originator-client';

import type { DemandApiQueryDto } from '@portal/common';

import { OriginatorActionType } from './actionTypes';

export const getDemandApisBySubAccountUuidAction = createAsyncAction(
  OriginatorActionType.GET_DEMAND_APIS_BY_SUBACCOUNT_UUID_REQUEST,
  OriginatorActionType.GET_DEMAND_APIS_BY_SUBACCOUNT_UUID_SUCCESS,
  OriginatorActionType.GET_DEMAND_APIS_BY_SUBACCOUNT_UUID_FAILURE
)<{ uuid: string }, { demandApis: DemandApi[]; uuid: string }, unknown>();

export const getDemandApisAction = createAsyncAction(
  OriginatorActionType.GET_DEMAND_APIS_REQUEST,
  OriginatorActionType.GET_DEMAND_APIS_SUCCESS,
  OriginatorActionType.GET_DEMAND_APIS_FAILURE
)<DemandApiQueryDto, DemandApi[], unknown>();

export const createSecondLookOfferConfigurationAction = createAsyncAction(
  OriginatorActionType.CREATE_SLOC_REQUEST,
  OriginatorActionType.CREATE_SLOC_SUCCESS,
  OriginatorActionType.CREATE_SLOC_FAILURE
)<SecondLookOfferConfigurationCreateData, undefined, unknown>();

export const getSecondLookOfferConfigurationsBySupplySubAccountIdAction =
  createAsyncAction(
    OriginatorActionType.GET_SLOCS_BY_SUPPLY_SUB_ACCOUNT_ID_REQUEST,
    OriginatorActionType.GET_SLOCS_BY_SUPPLY_SUB_ACCOUNT_ID_SUCCESS,
    OriginatorActionType.GET_SLOCS_BY_SUPPLY_SUB_ACCOUNT_ID_FAILURE
  )<
    { supplySubAccountId: number },
    {
      secondLookOfferConfigurations: SecondLookOfferConfiguration[];
      supplySubAccountId: number;
    },
    unknown
  >();
